export default __webpack_public_path__ + "static/media/travel-round-ban.13920d55.png";